import { createSlice } from '@reduxjs/toolkit';
import { sendGeneralRequest } from '../generalRequest';


const initialState = {
    address: '',
    balance: '',
    name:'',
    city:'',
    phone:'',
    transactionHistory: {transactions:[], tags:[]},
    defaultTransactionHistory: {transactions:[], tags:[]},
    displayName: '',
    token : '',
    username:'',
    isLoading: false,
    otp: '',
    idExpiryDate: '',
    idNumber:'',
    idPictureBase64: '',
    idPictureExtension:'',
    email:'',
    invoiceDataAutofill: '',
    accountType: '',
    areNotificationsFetched: false,
    shouldDisplayWelcomeCard: false,
    shouldTermsAndConditionsBeFetched: true,
    areEmailNotificationsActive: false,
    areEmailNotificationsSuccessfullySet: false,
    notifications: [],
    isFirstRun: true,
    isTransactionDataFiltered: false,
    isManualRegistration: false,
    canUserGenerateCode: false,
    isUserInvited: false,
    showInviteFriend: false,
};

export const userInfoSlice = createSlice({
    name: 'userInfo',
    initialState,
    reducers:
    {
        setToken: (state,action) => 
        {
            state.token = action.payload
        },
        setIsTransactionDataFiltered: (state,action) => 
        {
            state.isTransactionDataFiltered = action.payload
        },
        setShouldDisplayWelcomeCard: (state, action) => 
        {
            state.shouldDisplayWelcomeCard = action.payload
        },
        setAreNotificationsFetched: (state, action) => 
        {
            state.areNotificationsFetched = action.payload
        },
        setInvoiceDataAutofill: (state,action) => 
        {
            state.invoiceDataAutofill = action.payload
        },
        setOtp: (state,action) => 
        {
            state.otp = action.payload
        },
        setIdExpiryDate: (state,action) => 
        {
            state.idExpiryDate = action.payload
        },
        setIdNumber: (state,action) => 
        {
            state.idNumber = action.payload
        },
        setIdPictureBase64: (state,action) => 
        {
            state.idPictureBase64 = action.payload
        },
        setIdPictureExtension: (state,action) => 
        {
            state.idPictureExtension = action.payload
        },
        setUsername: (state,action) => 
        {
            state.username = action.payload
        },
        setName: (state,action) => 
        {
            state.name = action.payload
        },
        setCity: (state,action) => 
        {
            state.city = action.payload
        },
        setBalance: (state,action) => 
        {
            state.balance = action.payload
        },
        setAddress: (state,action) => 
        {
            state.address = action.payload
        },
        setIsLoading: (state,action) => 
        {
            state.isLoading = action.payload
        },
        setEmail: (state,action) => 
        {
            state.email = action.payload
        },
        setPhone: (state,action) => 
        {
            state.phone = action.payload
        },
        setDisplayName: (state,action) => 
        {
            state.displayName = action.payload
        },
        setUserInfoAccountType: (state, action) => 
        {
            state.accountType = action.payload
        },
        setAreEmailNotificationsSuccessfullySet: (state, action) => 
        {
            state.areEmailNotificationsSuccessfullySet = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(sendGeneralRequest.pending, (state) => {
                state.isLoading = true
            }) 
            .addCase(sendGeneralRequest.rejected, (state) => {
                state.isLoading = false
            }) 
            .addCase(sendGeneralRequest.fulfilled, (state, action) => {
                state.isLoading = false
                // if(action.payload.endpoint === 'GetAccountInfo')
                // {   
                    
                //     state.email = action.payload.response.data.Email
                //     state.username = action.payload.response.data.Username        
                //     state.balance = action.payload.response.data.Balance
                //     state.displayName = action.payload.response.data.Name
                //     state.banks = action.payload.response.data.BankInfo
                //     state.bankId = action.payload.response.data.BankID
                // }
                if(action.payload.endpoint === 'GetAccountInfoNew')
                {     
                    state.address = action.payload.response.data.Address
                    state.balance = action.payload.response.data.Balance      
                    state.city = action.payload.response.data.City
                    state.name = action.payload.response.data.Name
                    state.phone = action.payload.response.data.Phone
                    state.isManualRegistration = action.payload.response.data.isManualRegistration
                }
                else if(action.payload.endpoint === 'GetBalance')
                {   
                    state.balance = action.payload.response.balance      
                }
                       
                else if(action.payload.endpoint === 'GetStatement')
                {
                    state.transactionHistory = {
                        statement: action.payload.response.statement,
                        transactions: action.payload.response.statement.transactions.map(transaction => {
                                return {
                                    serviceName: transaction.tag,
                                    date: transaction.date,
                                    type: transaction.type,
                                    value: transaction.value,
                                    serviceLogo: transaction.serviceLogo,
                                    transId: transaction.transID,
                                    serial: transaction.serial,
                                    productName: transaction.productName,
                                    channel: transaction.channel,
                                    details: transaction.details
                                }
                            }),
                        tags: action.payload.response.statement.tags
                    }

                    if(state.isFirstRun) { 
                        state.defaultTransactionHistory = state.transactionHistory
                        state.isFirstRun = false
                    }
                    // state.latestTransactions = action.payload.response.statement.transactions.map(transaction => {
                    //     return {
                    //         serviceName: transaction.tag,
                    //         date: transaction.date,
                    //         type: transaction.type,
                    //         value: transaction.value,
                    //         serviceLogo: transaction.serviceLogo
                    //     }
                    // })
                    
                    // state.transactionTags = action.payload.response.statement.tags
                }
                else if(action.payload.endpoint === 'StatementFileManagment')
                {
                    state.response = action.payload.response.stream
                } 
                else if(action.payload.endpoint === 'GetServicesNotifications')
                {
                    state.areEmailNotificationsSuccessfullySet = false
                    state.notifications = action.payload.response.servicesList
                    state.areEmailNotificationsActive = action.payload.response.servicesList[0].emailActive
                }
                else if(action.payload.endpoint === 'SetNotificationsPerAllServices')
                {
                    state.areEmailNotificationsSuccessfullySet = true
                }
                else if(action.payload.endpoint === 'News/GetAll')
                {
                    state.news = action.payload.response.news
                }
                else if(action.payload.endpoint === 'InviteFriend/CheckInviteFriend')
                {
                    state.showInviteFriend = action.payload.response.success
                    state.isUserInvited = action.payload.response.isUserInvited
                    state.canUserGenerateCode = action.payload.response.canUserGenerateCode
                }
            })
    }, 
})

export const { setToken, setPhone, setEmail, setName, setAddress, setAreNotificationsFetched, setShouldDisplayWelcomeCard, setCity, setAreEmailNotificationsSuccessfullySet, setBalance,setIsLoading,setOtp,setIdExpiryDate,setIdNumber,setIdPictureExtension,setIdPictureBase64,setDisplayName,setInvoiceDataAutofill,setUserInfoAccountType, setUsername, setIsTransactionDataFiltered } = userInfoSlice.actions;

export const selectUserInfo = (state) => state.userInfo;

export default userInfoSlice.reducer;